import React, { useContext } from "react";
import { ConfirmDialog, DeleteButton, ListActionButtonProps, useDisclosure, useNotifications } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../core/security/SprintAccessRight";
import { useAdminWatermarkRuleApi } from "../../../api/useAdminWatermarkRuleApi";
import { WatermarkRuleContext } from "../../../context/WatermarkRuleContext";
import { WatermarkRuleItem } from "../../WatermarkRuleItem";

type DeleteWatermarkRuleButtonProps = ListActionButtonProps<WatermarkRuleItem>;

export const DeleteWatermarkRuleButton: React.VFC<DeleteWatermarkRuleButtonProps> = ({
    itemId
}: DeleteWatermarkRuleButtonProps) => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    const { deleteWatermarkRule } = useAdminWatermarkRuleApi();

    const { success } = useNotifications();
    const { deleteWatermarkRuleItem } = useContext(WatermarkRuleContext);

    const handleDelete = async () => {
        await deleteWatermarkRule({ ruleId: itemId });
        deleteWatermarkRuleItem(itemId);

        success("Watermark rule deleted");

        onClose();
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AdminReadWrite]}>
            <DeleteButton key={itemId} onClick={onOpen} />
            <ConfirmDialog
                title="Delete watermark rule"
                text="Are you sure you want to delete this watermark rule?"
                hidden={!isOpen}
                confirm={{ onClick: handleDelete }}
                cancel={{ onClick: onClose }}
                width={500}
            />
        </AuthorizationWrapper>
    );
};
